package ui.license


import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.utils.*
import tools.*
import ui.license.detail.*
import ui.widget.*


@ComposableNavNode
@Composable
fun LicenseListingUI() {
    with(LicenseListingScope.rememberScope()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }
    }
}


@OptIn(ExperimentalFoundationApi::class)
@Composable
fun LicenseListingScope.Content(nnvl: LicenseListingScope.Wrapper) {
    Column(Modifier.fillMaxSize().padding(top = 8.dp).padding(start = 8.dp)) {
        HomeSearchUI(vm.searchFiled, label = Res.string.license_listing__search)
        Space(8.dp)
        val stateHorizontal = rememberScrollState(0)
        val itemMeasurer = headers.rememberMeasurer(16.dp)
        Box(Modifier.fillMaxSize()) {
            Box(
                Modifier.fillMaxSize()
                    .tableMeasurer(itemMeasurer)
                    .horizontalScroll(stateHorizontal)
            ) {
                LazyColumn(
                    contentPadding = PaddingValues(end = 8.dp),
                    modifier = Modifier.fillMaxHeight()
                        .width(itemMeasurer.rowWidth)
                ) {
                    stickyHeader {
                        ListingHeader(headers)
                    }
                    itemsIndexed(
                        SearchWrapper.use(
                            fields = arrayOf(
                                Io.ServerLicensing.Company::id,
                                Io.ServerLicensing.Company::idHex,
                                Io.ServerLicensing.Company::name
                            ),
                            items = nnvl.state,
                            query = vm.searchFiled,
                            sort = compareByDescending<LicenseListingScope.Wrapper.Item> {
                                if (it.data.id == login.server.id) 1 else 0
                            }.thenByDescending {
                                if (it.data.id < 1000) Long.MAX_VALUE - it.data.id else it.data.id
                            }
                        )) { _, item ->
                        ListingDivider()
                        ListingItem(
                            item = item,
                            specs = headers,
                            background = if (login.server.id == item.data.id) MaterialTheme.colorScheme.tertiaryContainer
                            else MaterialTheme.colorScheme.surfaceContainer
                        ) {
                            nav.findRoot().navTo_LicenseDetailUI(LicenseArgs(item.data.id))
                        }
                    }

                    ListingFooter()
                }
            }
            HorizontalScrollbar(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .padding(bottom = 8.dp)
                    .fillMaxWidth(),
                adapter = rememberScrollbarAdapter(stateHorizontal)
            )
        }
    }
}

